const ButtonDeleteSvg = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1667 3.99998V3.46665C11.1667 2.71991 11.1667 2.34654 11.0213 2.06133C10.8935 1.81044 10.6895 1.60647 10.4387 1.47864C10.1534 1.33331 9.78007 1.33331 9.03333 1.33331H7.96667C7.21993 1.33331 6.84656 1.33331 6.56135 1.47864C6.31046 1.60647 6.10649 1.81044 5.97866 2.06133C5.83333 2.34654 5.83333 2.71991 5.83333 3.46665V3.99998M2.5 3.99998H14.5M13.1667 3.99998V11.4666C13.1667 12.5868 13.1667 13.1468 12.9487 13.5746C12.7569 13.951 12.451 14.2569 12.0746 14.4487C11.6468 14.6666 11.0868 14.6666 9.96667 14.6666H7.03333C5.91323 14.6666 5.35318 14.6666 4.92535 14.4487C4.54903 14.2569 4.24307 13.951 4.05132 13.5746C3.83333 13.1468 3.83333 12.5868 3.83333 11.4666V3.99998"
      stroke="#EA1C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ButtonDeleteSvg;
